import React from "react";

import { SearchComponent } from "@utils/search/@types/searchComponent";

import { ContentResultListHitComponent } from "@components/Search/SearchResults/StateComponents/ResultList/hit/contentResultListHit.component";
import { ProductResultListHitComponent } from "@components/Search/SearchResults/StateComponents/ResultList/hit/productResultListHit.component";
import { ResultList } from "@components/Search/SearchResults/StateComponents/ResultList/resultList.container";

import { ContentPageAlgoliaModel } from "../../../../../@types/service/product/algolia/contentPage.algolia.model";
import { ProductAlgoliaModel } from "../../../../../@types/service/product/algolia/product.algolia.model";
import { SearchResultProductTileConfig } from "../../searchResults.container";

type ProductResultListProps = {
    productTileConfig?: SearchResultProductTileConfig;
};

const ProductResultList = ({ productTileConfig }: ProductResultListProps) => (
    <ResultList<ProductAlgoliaModel>
        component={SearchComponent.PRODUCT_RESULT_LIST}
        keyExtractor={hit => hit.sku}
        HitComponent={({ hit }) => (
            <ProductResultListHitComponent
                hit={hit}
                productTileConfig={productTileConfig}
            />
        )}
    />
);

const ContentResultList = () => (
    <ResultList<ContentPageAlgoliaModel>
        component={SearchComponent.CONTENT_RESULT_LIST}
        keyExtractor={hit => hit.objectID}
        HitComponent={ContentResultListHitComponent}
    />
);

export { ContentResultList, ProductResultList };
